import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { Route, Link, withRouter, Redirect } from "react-router-dom"
import LoadingOverlay from "./general/loadingOverlay"
import Overlay from "./general/overlay"
import classNames from "classnames"
import { loadingStatus, setActiveProperties, getPayload, setViewAs } from "../actions"
import settings from "settings"
import ARC from "./entry/arc"
import ARCSubmitMaster from "./entry/arcSubmitMaster"
import Account from "./general/account"
import LotInventory from "./entry/lot-inventory"
import ReactSelect from "components/ReactSelect"
import ARCEditMaster from "./entry/arcEditMaster"
const EntryLotMap = React.lazy(() => import("./reports/entryLotMap"))
import LotStatus from "./reports/lotStatus"
import Floorplans from "./entry/floorplans"
import Floorplan from "./entry/floorplan"
import { compose } from "redux"
import axios from "axios"
import _ from "lodash"
import helpers from "helpers/helpers"
import Modal from "react-responsive-modal"
import ViewAs from "components/ViewAs"

class ARCInterface extends Component {
	constructor(props) {
		super(props)
		this.state = {
			invalid: false, // making sure managers can't login to entry section
			noActivityModal: false,
			navOpen: false,
			viewAs: false,
			viewAsID: 0,
			nav: [
				{
					title: "LOT INVENTORY",
					icon: "fa-usd-circle",
					link: "/arc/lot-inventory",
				},
				{
					title: "ARC PORTAL",
					icon: "fa-upload",
					link: "/arc",
				},
				{
					title: "LOT STATUS",
					icon: "fa-map-marked-alt",
					link: "/arc/lot-status",
				},
				{
					title: "LOT MAP",
					icon: "fa-map-marker-check",
					link: "/arc/lot-map",
				},
			],
		}
	}

	componentDidMount() {
		// Check that this is a salesperson and not a manager
		let jwtDecode = require("jwt-decode")
		let user = localStorage.getItem("user")
		user = jwtDecode(user)
		let activeProperties = localStorage.getItem("activeProperties")
		// Viewing as admin
		if (activeProperties && localStorage.getItem("viewAs")) {
			this.props.setActiveProperties(JSON.parse(activeProperties))
		} else if (user.activeProperties && user.aud == 1) {
			// Viewing as salesperson directly - no view as
			this.props.setActiveProperties(user.activeProperties)
		} else if (user?.activeProperties?.length) {
			this.props.setActiveProperties([user.activeProperties[0]])
		}
		if (localStorage.getItem("viewAs")) {
			let sp = jwtDecode(localStorage.getItem("viewAs"))
			this.props.setViewAs(sp.id)
		}
		this.props.getPayload()
	}

	renderNav() {
		// use the third array item to determine where we are in the entry section
		var pathArray = window.location.pathname.split("/")
		var classNames = require("classnames")
		let nav = _.cloneDeep(this.state.nav)
		if (_.get(settings, "enabled.arcUserFloorplans")) {
			nav.push({
				title: "Floorplans",
				icon: "fa-notebook",
				link: "/arc/floorplans",
			})
		}
		return nav.map((r, i) => {
			var path = r.link.split("/")
			var here = path[2] == pathArray[2] ? true : false
			var classes = classNames("body__navItem", {
				here: here,
			})
			return (
				<li key={i} className={classes} onClick={this.toggleMobileMenu}>
					<Link to={r.link}></Link>
					<div className="body__navTitle">
						<i className={`fas ${r.icon} fa-2x`}></i>
						<span>{r.title}</span>
					</div>
				</li>
			)
		})
	}

	backtoAdmin = () => {
		localStorage.removeItem("viewAs")
		this.props.setViewAs(0)
	}

	changeUser = (v) => {
		var userToken = localStorage.getItem("user")
		axios
			.post(
				settings.ep + "/generateViewAsToken",
				{ id: v, activeProperties: this.props.activeProperties },
				{
					headers: { Authorization: `Bearer ${userToken}` },
				}
			)
			.then((response) => {
				localStorage.setItem("viewAs", response.data.token)
				// Check what the person they want to view as is.
				let find = _.find(this.props.payload.users, { id: v })
				let viewAsID = find ? find.group : null
				this.props.setViewAs(v)
				this.setState({ viewAs: true, viewAsID })
				this.props.getPayload()
			})
			.catch((error) => {
				// need error handling
				this.props.loadingStatus(false)
			})
	}

	viewAsBack = () => {
		if (localStorage.getItem("viewAs")) {
			let url = localStorage.getItem("currentPath") ? localStorage.getItem("currentPath") : "/"
			return (
				<li onClick={this.backtoAdmin}>
					<Link to={url} className="flex h-full items-center">
						Back to Admin
					</Link>
				</li>
			)
		}
	}

	viewAsName = () => {
		if (localStorage.getItem("viewAs")) {
			let salesperson = _.find(this.props.payload.public.salespeople, { id: this.props.viewAs })
			if (!salesperson) {
				return
			}
			return (
				<span className="viewAs__name">
					Viewing as: {salesperson.first} {salesperson.last}
				</span>
			)
		}
	}

	viewAsSelect = () => {
		if (localStorage.getItem("viewAs")) {
			return (
				<li>
					<div className="top__viewAs">
						<p className="top__selectTitle">View As:</p>
						<ViewAs
							options={helpers.listViewAsUsers(
								this.props.payload.users,
								this.props.payload.public.builders,
								this.props.activeProperties
							)}
							value={this.props.viewAs}
							onChange={(v) => this.changeUser(v)}
							onBlur={() => {}}
							className="top__select"
							classNamePrefix="multiSelect"
							clearable
						/>
					</div>
				</li>
			)
		}
	}

	requestHelp = () => {
		if (localStorage.getItem("viewAs")) {
			//return
		}
		if (!this.props.payload.salespersonPayload.help) {
			return
		}
		return (
			<>
				<p className="portal__help">
					Need help?
					<br />
				</p>
				<p className="portal__help">
					<a href={`mailto:${this.props.payload.salespersonPayload.help}`}>REQUEST HELP</a>
				</p>
			</>
		)
	}

	listProperties = (v) => {
		let users = helpers.bothUsers()
		if (
			users.admin.activeProperties &&
			typeof users.admin.activeProperties == "object" &&
			users.admin.activeProperties.length > 0
		) {
			let arr = []
			_.forEach(this.props.payload.public.properties, (v) => {
				if (users.admin.activeProperties.includes(v.id)) {
					arr.push({
						value: v.id,
						label: v.name,
					})
				}
			})
			arr = _.sortBy(arr, "label")
			return arr
		}
		return []
	}

	changeProperties = (v) => {
		// ARC can only have one active property at a time.
		if (!v) {
			v = []
		}
		let f = [v]
		if (f.length == 0) {
			localStorage.removeItem("activeProperties")
		} else {
			localStorage.setItem("activeProperties", JSON.stringify(f))
		}

		this.props.setActiveProperties(f)
		this.props.getPayload()
	}

	viewAs = () => {
		return (
			<div className="top__propertyPicker">
				<p className="top__selectTitle">Active Property:</p>
				<ReactSelect
					//isMulti
					options={this.listProperties()}
					value={this.props.activeProperties}
					onChange={(a, b) => this.changeProperties(b)}
					onBlur={() => {}}
					className="top__select"
					classNamePrefix="multiSelect"
				/>
			</div>
		)
	}

	emailCommunityManagers = () => {
		if (this.props.payload.salespersonPayload.communityManagers) {
			return (
				<a
					className="portal__communityManagers"
					href={`mailto:${this.props.payload.salespersonPayload.communityManagers}`}>
					Need Help? Email Us
				</a>
			)
		}
	}

	displayPortalLinks = () => {
		let ret = []
		_.forEach(this.props.activeProperties, (prop) => {
			let check = _.find(this.props.payload.public.properties, { id: prop })
			if (check && check.portal_links && check.portal_links.length > 0) {
				// This property has portal links
				let i = 0
				_.forEach(check.portal_links, (v) => {
					ret.push(
						<li className={v.color} key={i}>
							<a href={v.link} target="_blank">
								{v.title}
							</a>
						</li>
					)
					i++
				})
			}
		})

		let f = <ul className="portal__sideNav portal__sideNav--links">{ret}</ul>

		return f
	}

	displayGlobalAlert = () => {
		let check = {}
		// Check global first, then check individual property messages
		_.forEach(this.props.payload.public.options.globalAlerts, (v) => {
			let compare = _.intersection(v.properties, this.props.activeProperties)
			if (compare.length > 0) {
				check = v
			}
		})
		if (!check.message) {
			let property = _.find(this.props.payload.public.properties, { id: this.props.activeProperties[0] })
			if (property && property.portal_message) {
				check.message = property.portal_message
			}
		}
		if (check.message) {
			return (
				<div className="globalAlert">
					<div className="c">
						<p dangerouslySetInnerHTML={{ __html: check.message }}></p>
					</div>
				</div>
			)
		} else return ""
	}

	toggleMobileMenu = (r) => {
		if (r.path === false) {
			return
		}
		this.setState({
			navOpen: !this.state.navOpen,
		})
	}

	displayInterface = () => {
		return (
			<>
				{this.displayGlobalAlert()}
				<div className="globalCont c">
					<div className="top">
						<div className="top__logo">
							<Link to="/entry/dashboard">
								<img src={settings.logo} alt="Pipsy" className="top__logoImg" />
							</Link>
						</div>
						<div className="top__global">
							{this.viewAs()}
							<div>
								<ul className="top__globalList">
									{this.viewAsBack()}
									{this.viewAsSelect()}
									{/*<li><i className="far fa-bell"></i></li>*/}
									<li>
										<Link to="/entry/account">
											<i className="far fa-user-cog"></i>
										</Link>
									</li>
									<li>
										<Link to="/logout">
											<i className="far fa-power-off"></i>
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div className="body">
						<div className="body__nav">
							<ul
								className={classNames("body__navList", {
									active: this.state.navOpen,
								})}>
								<li className="body__mobileClose" onClick={this.toggleMobileMenu}>
									<i className="far fa-times-octagon" />
								</li>
								<li className="body__mobileLogo">
									<img src="/img/logo.svg" alt="Pipsy" />
								</li>
								{this.renderNav()}
							</ul>
							<div className="portal__sideNav">
								{this.emailCommunityManagers()}
								{!settings.arc && (
									<a href={`mailto:${settings.corporateContact}?subject=New Floor Plan Request`}>
										Submit New Floor Plan
									</a>
								)}
							</div>
							<div className="portal__portalLinks">{this.displayPortalLinks()}</div>
						</div>
						<div className="body__stageCont">
							<div className="body__stage" id="stage">
								<Route path="/arc/account" exact component={Account} />
								<Route path="/arc" exact component={ARC} />
								<Route path="/arc/new" exact component={ARCSubmitMaster} />
								<Route path="/arc/lot-inventory" exact component={withRouter(LotInventory)} />
								<Route path="/arc/edit/:id" exact component={ARCEditMaster} />
								<Route path="/arc/floorplans" exact component={Floorplans} />
								<Route path="/arc/floorplan/:id" component={Floorplan} />
								<Route path="/arc/lot-status" exact component={LotStatus} />
								<Route path="/arc/lot-map" exact component={withRouter(EntryLotMap)} />
							</div>
						</div>
					</div>
					<p className="body__issues">
						Issues or comments? Email us at{" "}
						<a href={`mailto:${settings.issueEmail}`}>{settings.issueEmail}</a> |{" "}
						<a href="https://www.pipsy.io">Pipsy</a> | Master Planned Community Engine | Made in Texas
					</p>
					<LoadingOverlay />
					<Overlay />
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.noActivityModal}
						onClose={() => this.setState({ noActivityModal: false })}
						center></Modal>
				</div>
			</>
		)
	}

	render() {
		if (this.state.invalid) {
			return <Redirect to={"/login"} />
		} else if (this.state.viewAs) {
			// Go through and check what type of user this is
			if (this.state.viewAsID === 2) {
				return <Redirect to={`/salesManager/dashboard`} />
			} else if (this.state.viewAsID === 13) {
				return <Redirect to={`/entry/dashboard`} />
			} else if (this.state.viewAsID === 15) {
				return <Redirect to={`/superintendent/lot-inventory`} />
			}
			return this.displayInterface()
		} else {
			return this.displayInterface()
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		payload: state.payload,
		viewAs: state.viewAs,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
			setViewAs,
			setActiveProperties,
		},
		dispatch
	)
}

export default compose(connect(mapStateToProps, matchDispatchToProps))(ARCInterface)
